import { Card, Dialog, Loader } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';
import Button from '../../components/elements/Button';
import CopyButton from '../../components/elements/CopyButton';
import ModalExpiredToken from '../../components/fragments/ModalExpiredToken';
import IconArrowLeft from '../../components/icons/IconArrowLeft';
import IconError from '../../components/icons/IconError';
import { formatCountdown } from '../../utils/format';
import { clearStorages, getTempToken } from '../../utils/storage';
import { isAppleDevice } from '../../utils/validation';
import { fetchQrMfa } from './action';
import styles from './styles.scoped.css';

function MfaScanCode() {
  const invalidCode = [403,401];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dateNow = new Date();
  const dataScanQr = useSelector((s) => s.scanCodeMfa);
  const [modal, setModal] = useState(false);
  const [isSession, setIsSession] = useState(false);
  const [alert, setALert] = useState(false);
  const { minutes, seconds, restart } = useTimer({
    expiryTimestamp: dateNow,
    onExpire: () => {
      setIsSession(true);
      setModal(true);
    },
    autoStart: false
  });

  const handleRelog = () => {
    clearStorages();
    navigate('/login');
  };

  useEffect(() => {
    if(getTempToken()){
      dispatch(fetchQrMfa());
    }else{
      clearStorages();
      location.replace('/dc/login');
    }
  }, []);
  useEffect(() => {
    if(dataScanQr.data && dataScanQr?.data?.countdown){
      const time = new Date();
      time.setSeconds(time.getSeconds() + dataScanQr?.data?.countdown);
      restart(time);
    }
    if(!dataScanQr.isLoading && !dataScanQr.success){
      if(dataScanQr?.message?.includes('Unsupported') || invalidCode.includes(dataScanQr?.code)){
        setModal(true);
      }else{
        setALert(true);
        const timeout = setTimeout(() => {
          setALert(false);
        }, 3000);
        return () => clearTimeout(timeout);
      }
    }
  }, [dataScanQr.isLoading]);

  const urlDownloadApps = isAppleDevice() ? 'https://apps.apple.com/id/app/microsoft-authenticator/id983156458?l=id' : 'https://play.google.com/store/apps/details?id=com.azure.authenticator';
  return (
    <div className={styles.root}>
      <Dialog className={styles.alertError} opened={alert} position={{ top: 20, left: '50%', transform: 'translate(-50%, -20%)' }}>
        <IconError/>
        {dataScanQr?.message || 'Terjadi kesalahan teknis dalam sistem.'}
      </Dialog>
      <Card className={styles.cardLogin} withBorder>
        <span className={styles.btnBack} onClick={handleRelog}><IconArrowLeft/> Keluar</span>
        <div className={styles.body}>
          <h3>Hubungkan Aplikasi Authenticator</h3>
          <span>
            Untuk keamaan akun Anda, hubungkan akun Anda dengan aplikasi Microsoft Authenticator.
          </span>
          <br/>
          <a className={styles.btnUnduhApp} href={urlDownloadApps} target="_blank">Unduh Aplikasi Authenticator</a>
          <hr className={styles.separator}/>
          <span>Pindai kode QR di bawah dengan aplikasi authenticator
             sebelum: <b>{formatCountdown(minutes,seconds)}</b></span>
          {dataScanQr?.data?.uri && <div className={styles.qrContainer}>
            <QRCode size={200} value={dataScanQr?.data?.uri}/>
            <div className={styles.txtCopy}>
              {dataScanQr?.data?.qrCode}<CopyButton value={dataScanQr?.data?.qrCode}/></div>
          </div>}
          {dataScanQr.isLoading &&
          <>
            <br/>
            <Loader color="blue"/>
            <br/>
          </>}
          <span>Jika Anda tidak dapat memindai kode QR di atas,
              harap masukkan kode di atas ke aplikasi authenticator.</span>
          <br/>
          <Button className={styles.btnContinue} onClick={() => navigate('/mfa/totp')} style={'blue'} >Selanjutnya</Button>
        </div>
      </Card>
      <ModalExpiredToken
        message={dataScanQr?.message} opened={modal}
        setModal={setModal}
        title={(invalidCode.includes(dataScanQr?.code) || isSession)
          ? 'Waktu Sesi Login Anda Habis' : 'Terjadi Kesalahan Autentikasi'}/>
    </div>
  );
}

export default MfaScanCode;
